/**
 * The strings the viewer chrome shows, whatever it is showing (FIL-8a, FIL-8b).
 *
 * Only what genuinely belongs to *any* viewer lives here — the frame's own
 * controls, and the three states of fetching bytes, which are the same act for
 * a photograph and a document. Anything a particular reader owns stays in its
 * own copy file: stepping between photographs is `imageViewer.copy.ts`, paging
 * through a document is `pdfViewer.copy.ts`.
 *
 * **The error lines say "file" rather than naming a format**, and that is a
 * deliberate narrowing from the image-only wording they replace. They are
 * reached when the API sent no message of its own, which is precisely the case
 * where this application knows least about what went wrong; a line that
 * confidently says "image" in front of a court filing is worse than one that
 * says nothing specific.
 *
 * Sentence case, no emoji, and the file's own name wherever a control could
 * otherwise be one of several identical ones — a screen reader hearing
 * "Download" three times on a page has been told nothing.
 */
export const VIEWER_COPY = {
  /** Used only when there is no filename to name the dialog with. */
  dialogLabel: 'File viewer',
  close: 'Close',
  more: (fileName: string) => `More actions for ${fileName}`,
  loading: 'Loading the file',
  loadingProgress: (percent: number) => `Loading ${String(percent)}%`,
  errors: {
    /** Only reached when the API sent no message of its own (`messageFrom`). */
    mint: 'That file could not be opened.',
    fetch: 'The file did not finish downloading.',
    retry: 'Try again',
  },
} as const;
